/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class NotificationPolicyConfigServiceNow {
  /**
  * The ServiceNow instance URL (e.g., https://mycompany.service-now.com)
  */
  'instanceUrl'?: string;
  /**
  * The ServiceNow API username
  */
  'username'?: string;
  /**
  * The ServiceNow API password
  */
  'password'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "instanceUrl",
      "baseName": "instanceUrl",
      "type": "string",
      "format": ""
    },
    {
      "name": "username",
      "baseName": "username",
      "type": "string",
      "format": ""
    },
    {
      "name": "password",
      "baseName": "password",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return NotificationPolicyConfigServiceNow.attributeTypeMap;
  }

  public constructor() {
  }
}

